<template>
  <a-spin :spinning="creating">
    <div class="container">
      <SeatInfo v-model:num="data.num"></SeatInfo>
      <a-button
        type="primary"
        :loading="creating"
        class="pay-button"
        @click="onPaymentClick"
      >
        {{ $t('qu-zhi-fu') }}
      </a-button>
    </div>
  </a-spin>
</template>

<script setup lang="ts" name="BuyRights">
import useOrder from './useOrder'
import SeatInfo from './seat-info.vue'
import { hpp } from '~/features/payment/airwallex'

const data = reactive({ num: 1 })

const { order, creating } = useOrder(data)

const onPaymentClick = () => {
  hpp('payment', {
    customer_id: order.value!.other_info.vendor_customer_id,
    currency: order.value!.currency,
    client_secret: order.value!.other_info.airwallex_client_secret,
    intent_id: order.value!.vendor_trade_no,
    successUrl: `${location.origin}/paymentResult?xmov_oid=${order.value?.id}`,
    failUrl: `${location.origin}/paymentResult?xmov_oid=${order.value?.id}`,
  })
}
</script>

<style lang="scss" scoped>
.container {
  padding: 30px;
  background-color: #181c25;
  border-radius: 12px;
}
.pay-button {
  display: block;
  width: 280px;
  height: 40px;
  margin: 58px auto 0;
}
</style>
